import type { ChangeEvent } from 'react'

import { useCallback } from 'react'

import { deleteOrderSteps } from '@/features/domain/order'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useTexts } from '../useTexts'
import { useController } from './useController'

export interface ModalHandlers {
  onCancel: () => void
  onDeleteOrder: () => void
}

export function useControllerActions() {
  const texts = useTexts()
  const toast = useNotification()
  const dispatch = useAppDispatch()
  const {
    close,
    updateData,
    data: { selectedOrders, pairedOrders, deleteAlsoPaired, targetRange },
  } = useController()

  const onDeleteOrder = useCallback(async () => {
    try {
      close?.()
      const idsToDelete = selectedOrders.map(order => order.orderStep.id)

      if (deleteAlsoPaired && !!pairedOrders && pairedOrders.length > 0)
        idsToDelete.push(...pairedOrders.map(order => order.id))

      await dispatch(deleteOrderSteps({ orderStepIds: idsToDelete, targetRange }))
    } catch (e) {
      toast.error(texts.genericDeleteOrderError)
    }
  }, [pairedOrders, selectedOrders, deleteAlsoPaired, targetRange, texts, toast, close, dispatch])

  const onDeleteAlsoPairedChange = useCallback(
    (_e: ChangeEvent<HTMLInputElement>, checked: boolean) =>
      updateData({ deleteAlsoPaired: checked }),
    [updateData],
  )

  const onChangeTargetRange = useCallback(
    (targetRange: uui.domain.ui.forms.TargetRange) => updateData({ targetRange }),
    [updateData],
  )

  return { onDeleteOrder, onDeleteAlsoPairedChange, onChangeTargetRange }
}
